import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  setAllDevices: '[setAllDevices] Action',
  setLiveDevices: '[setLiveDevices] Action',
  setDailyList: '[setDailyList] Action',
  setSelectedDevice: '[setSelectedDevice] Action',
  setDeviceLiveInfo: '[setDeviceLiveInfo] Action',
  setCustomer: '[setCustomer] Action',
  setDeviceDrivingInfo: '[setDeviceDrivingInfo] Action',
}

let allDevices: any = []
let liveDevices: any = []
let dailyList: any = []
let selectedDevice: any = {}
let deviceLiveInfo: any = {}
let customer: any = {}
let deviceDrivingInfo: any = {}

const initialDevicesState: any = {
  allDevices: allDevices ? allDevices : null,
  liveDevices: liveDevices ? liveDevices : null,
  dailyList: dailyList ? dailyList : null,
  selectedDevice: selectedDevice ? selectedDevice : {},
  customer: customer ? customer : {},
  deviceLiveInfo: deviceLiveInfo ? deviceLiveInfo : {},
  deviceDrivingInfo: deviceDrivingInfo ? deviceDrivingInfo : {},
}

export const reducer = persistReducer(
  {storage, key: 'v1-dhg-devices', whitelist: ['devices']},
  (state: any = initialDevicesState, action: any) => {
    switch (action.type) {
      case actionTypes.setAllDevices: {
        return {...state, allDevices: action.allDevices}
      }

      case actionTypes.setLiveDevices: {
        return {...state, liveDevices: action.liveDevices}
      }

      case actionTypes.setDailyList: {
        return {...state, dailyList: action.dailyList}
      }

      case actionTypes.setSelectedDevice: {
        return {...state, selectedDevice: {...action.selectedDevice}}
      }

      case actionTypes.setDeviceLiveInfo: {
        return {...state, deviceLiveInfo: {...action.deviceLiveInfo}}
      }

      case actionTypes.setCustomer: {
        return {...state, customer: {...action.customer}}
      }

      case actionTypes.setDeviceDrivingInfo: {
        return {...state, deviceDrivingInfo: {...action.deviceDrivingInfo}}
      }

      default:
        return state
    }
  }
)

export const actions = {
  setAllDevices: (allDevices: any) => ({type: actionTypes.setAllDevices, allDevices: allDevices}),
  setLiveDevices: (liveDevices: any) => ({
    type: actionTypes.setLiveDevices,
    liveDevices: liveDevices,
  }),
  setDailyList: (dailyList: any) => ({type: actionTypes.setDailyList, dailyList: dailyList}),
  setSelectedDevice: (selectedDevice: any) => ({
    type: actionTypes.setSelectedDevice,
    selectedDevice: selectedDevice,
  }),
  setDeviceLiveInfo: (deviceLiveInfo: any) => ({
    type: actionTypes.setDeviceLiveInfo,
    deviceLiveInfo: deviceLiveInfo,
  }),
  setCustomer: (customer: any) => ({
    type: actionTypes.setCustomer,
    customer: customer,
  }),
  setDeviceDrivingInfo: (deviceDrivingInfo: any) => ({
    type: actionTypes.setDeviceDrivingInfo,
    deviceDrivingInfo: deviceDrivingInfo,
  }),
}
